import { useState } from "react";
import { toast } from "sonner";
import { Coins } from "lucide-react";
import { errMsg, startCheckout } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PACKS = [
  { key: "tokens_100", tokens: 100, price: 10, tag: "Starter" },
  { key: "tokens_1000", tokens: 1000, price: 20, tag: "Best value · 5x more" },
];

export default function Tokens() {
  const { user } = useAuth();
  const [busy, setBusy] = useState("");
  const buy = async (k) => {
    setBusy(k);
    try { await startCheckout(k); } catch (e) { toast.error(errMsg(e)); setBusy(""); }
  };
  return (
    <main className="mx-auto max-w-5xl px-5 py-16 lg:px-8" data-testid="tokens-page">
      <p className="eyebrow mb-3">Token store</p>
      <h1 className="font-display mb-4 text-5xl sm:text-6xl">Spoil someone <span className="italic text-red-600">special.</span></h1>
      <p className="mb-14 text-zinc-400">Balance: <span data-testid="token-balance" className="text-amber-300">{user.tokens} tokens</span> · Tip girls in cam rooms, chats and on profiles.</p>
      <div className="grid gap-6 md:grid-cols-2">
        {PACKS.map((p) => (
          <div key={p.key} data-testid={`token-pack-${p.tokens}`} className="card-lux group p-10 hover:-translate-y-1">
            <p className="eyebrow mb-6 !text-amber-300">{p.tag}</p>
            <div className="flex items-end gap-3"><Coins className="mb-3 h-10 w-10 text-amber-400" strokeWidth={1.2} /><p className="font-display text-8xl leading-none">{p.tokens.toLocaleString()}</p></div>
            <p className="mt-2 text-zinc-400">tokens</p>
            <button data-testid={`token-pack-${p.tokens}-buy-btn`} disabled={!!busy} onClick={() => buy(p.key)} className="btn-red mt-10 w-full rounded-full py-3.5 font-semibold disabled:opacity-50">
              {busy === p.key ? "Redirecting…" : `Buy for $${p.price}`}
            </button>
          </div>
        ))}
      </div>
    </main>
  );
}
